import {
  endOfDay,
  endOfMonth,
  endOfWeek,
  startOfDay,
  startOfMonth,
  startOfWeek,
  subDays,
  subMonths,
  subWeeks,
} from "date-fns";

import type { DashboardPeriod } from "@/lib/dashboard/period";
import { getUkToday } from "@/lib/date-utils";

export interface DateRange {
  startDate: Date;
  endDate: Date;
}

// UK weeks start on Monday.
const WEEK_OPTIONS = { weekStartsOn: 1 } as const;

export function getPeriodRange(period: DashboardPeriod): DateRange {
  const now = getUkToday();
  if (period === "today") {
    return { startDate: startOfDay(now), endDate: endOfDay(now) };
  }
  if (period === "this_week") {
    return {
      startDate: startOfWeek(now, WEEK_OPTIONS),
      endDate: endOfWeek(now, WEEK_OPTIONS),
    };
  }
  return { startDate: startOfMonth(now), endDate: endOfMonth(now) };
}

export function getPreviousPeriodRange(period: DashboardPeriod): DateRange {
  const now = getUkToday();
  if (period === "today") {
    const previous = subDays(now, 1);
    return { startDate: startOfDay(previous), endDate: endOfDay(previous) };
  }
  if (period === "this_week") {
    const previous = subWeeks(now, 1);
    return {
      startDate: startOfWeek(previous, WEEK_OPTIONS),
      endDate: endOfWeek(previous, WEEK_OPTIONS),
    };
  }
  const previous = subMonths(now, 1);
  return { startDate: startOfMonth(previous), endDate: endOfMonth(previous) };
}
